import logo from 'assets/img/2026/logo1.png';
import { useAuth } from 'context/AuthContext';
import { useEffect, useState } from 'react';
import { RxExit } from 'react-icons/rx';
import { fetchRule } from 'services/rule.service';
import './style.scss';

interface SimpleHeaderProps {
  title: string;
  subtitle?: string;
  userName?: string;
  customLogo?: string;
}

export function SimpleHeader({ title, subtitle, userName, customLogo }: SimpleHeaderProps) {
  const { user, signOut } = useAuth();
  const [regulamentoUrl, setRegulamentoUrl] = useState<string | null>(null);
  const logoutPath = '/login';

  useEffect(() => {
    fetchRule().then((data: any) => {
      if (data?.regulation?.url) setRegulamentoUrl(data.regulation.url);
    }).catch(() => {});
  }, []);

  return (
    <div className="simple-header flex items-center gap-4 p-2 border-b-4 border-yellow-bb bg-blue-bb">
      <div className="simple-header__yellow-detail"></div>
      <div className="flex items-center justify-center relative z-10">
        <img src={logo} alt="Logo prêmio" className="h-20 w-auto ml-8" />      </div>
      <div className="text-yellow-bb font-bold text-lg relative z-10">
        {title}
        {subtitle && <span className="font-normal"> | {subtitle}</span>}
      </div>
      {regulamentoUrl && (
        <a
          href={regulamentoUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-yellow-bb font-semibold text-sm hover:underline relative z-10"
        >
          Regulamento
        </a>
      )}
      {(userName || user?.name) && (
        <div className="ml-auto flex items-center gap-3 text-white-bb font-medium relative z-10">
          <span className="text-sm uppercase">{userName || user?.name}</span>
          {user?.image?.small?.url && (
            <img
              src={user.image.small.url}
              alt={user?.name}
              className="w-10 h-10 rounded-full object-cover border-2 border-yellow-bb"
            />
          )}
          <button
            onClick={() => signOut(logoutPath)}
            className="text-white-bb hover:text-yellow-bb transition-colors"
            title="Sair"
          >
            <RxExit size={24} />
          </button>
        </div>
      )}
    </div>
  );
}
